import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fcp-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  public mini: boolean = true;
  @Input() helpdesk: any;

  constructor() { }

  ngOnInit() { }

  open(url: string) {
    const w = 650;
    const h = 650;
    const dualScreenLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(url, 'chat', 'scrollbars=yes, status=no, toolbar=no, location=no, directories=no, menubar=no, resizable=no, fullscreen=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    if (window.focus) newWindow.focus();
  }

}
